/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export type GetAllCohortsCohortsGetParams = {
  state?: string | null;
  page?: number;
  pageSize?: number;
  sort?: string;
  filter?: string;
};
